import React from 'react';
import { motion } from 'framer-motion';
import SectionHeader from './SectionHeader';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const Projects = ({ content }) => (
  <section id="projects" className="section section-light">
    <div className="container section-stack">
      <SectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.intro}
      />

      <div className="case-study-list">
        {content.items.map((project, index) => (
          <motion.article
            key={project.title}
            className="case-study"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.5, delay: index * 0.08 }}
          >
            <div className="case-study-header">
              <div>
                <p className="case-study-kicker">
                  {content.caseStudyLabel} {index + 1}
                  {project.category ? ` · ${project.category}` : ''}
                </p>
                <h3>{project.title}</h3>
              </div>

              {(project.badge || project.link) && (
                <div className="tag-list">
                  {project.badge && (
                    <strong className="tag subtle">{project.badge}</strong>
                  )}
                  {project.link && (
                    <a
                      className="button button-primary"
                      href={project.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {content.openProjectLabel}
                    </a>
                  )}
                </div>
              )}
            </div>

            <div className="case-study-grid">
              <div>
                <span>{content.problemLabel}</span>
                <p>{project.problem}</p>
              </div>
              <div>
                <span>{content.solutionLabel}</span>
                <p>{project.solution}</p>
              </div>
              <div>
                <span>{content.impactLabel}</span>
                <p>{project.impact}</p>
              </div>
              <div>
                <span>{content.roleLabel}</span>
                <p>{project.role}</p>
              </div>
            </div>

            <div className="case-study-stack">
              <span>{content.stackLabel}</span>
              <div className="tag-list">
                {project.stack.map((item) => (
                  <strong key={item} className="tag">
                    {item}
                  </strong>
                ))}
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
